import { NavLink, Outlet, useNavigate } from "react-router-dom";

import { useAuth } from "../services/auth-context";

const ADMIN_NAV_ITEMS = [
  { to: "/admin", label: "Dashboard", icon: "M3 3h7v7H3zm11 0h7v7h-7zM3 14h7v7H3zm11 0h7v7h-7z", end: true },
  { to: "/admin/workspaces", label: "Workspace", icon: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" },
  { to: "/admin/users", label: "Utenti", icon: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" },
  { to: "/admin/conversations", label: "Conversazioni", icon: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" },
  { to: "/admin/plans", label: "Piani", icon: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2" },
  { to: "/admin/audit", label: "Audit Log", icon: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8" },
  { to: "/admin/contacts", label: "Contatti", icon: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM22 6l-10 7L2 6" },
  { to: "/admin/appointments", label: "Appuntamenti", icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z" },
  { to: "/admin/workspace-health", label: "Health Score", icon: "M22 12h-4l-3 9L9 3l-3 9H2" },
];

function NavIcon({ d }: { d: string }) {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      style={{ flexShrink: 0, opacity: 0.75 }}>
      <path d={d} />
    </svg>
  );
}

export function AdminShell() {
  const { tokens, logout } = useAuth();
  const navigate = useNavigate();
  const hasWorkspace = Boolean(tokens?.workspace_id);

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand-block">
          <div className="brand-logo" style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            background: "linear-gradient(135deg, #0d9488, #14b8a6)",
            color: "#fff", fontWeight: 800, fontSize: "0.85rem",
          }}>SA</div>
          <div>
            <h2>IncassaFlow</h2>
            <p>Admin Panel</p>
          </div>
        </div>

        {/* Toggle Admin ↔ App */}
        {hasWorkspace && (
          <div className="role-toggle">
            <button className="role-toggle-btn active" type="button">Admin</button>
            <button className="role-toggle-btn" type="button" onClick={() => navigate("/dashboard")}>App</button>
          </div>
        )}

        <nav className="sidebar-nav">
          {ADMIN_NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
            >
              <NavIcon d={item.icon} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button type="button" className="ghost-btn" onClick={logout} style={{ marginTop: "auto" }}>
          &larr; Esci
        </button>
      </aside>

      <main className="page-content" id="main-content">
        <Outlet />
      </main>
    </div>
  );
}
